import { screenSize } from "../components/common/constants";

export const getCurrentScreenType = () => {
    const currentScreenSize = window.innerWidth;
    const screenTypes = Object.values(screenSize);
    let current = screenSize.DESKTOP_MD;
    screenTypes.some(st => {
      if (currentScreenSize <= st) {
        current = st;
        return true;
      }
    });
    return current;
  };


// WEBPACK FOOTER //
// ./src/utils/dom.helpers.js